import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import { FaApple, FaGooglePlay, FaShieldAlt, FaUsers, FaHeartbeat } from "react-icons/fa";
import productImg from "../assets/prod-afya.png"; // Ensure this asset exists
import AOS from "aos";
import "aos/dist/aos.css";

export default function ViewAfyaMingle() {
  const { navTo } = useContext(AppContext);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(true);
    AOS.init({
      duration: 1000,
      easing: "ease-out-expo",
      once: true
    });
  }, []);

  if (!ready) return <div className="container mSupportLoading">{getInlineLoader()}</div>;

  return (
    <main className="afyamingle-view position-relative overflow-hidden" style={{ background: '#ffffff', minHeight: '100vh' }}>
      
      {/* Structural Background */}
      <div className="position-absolute top-0 start-0 w-100 h-100" style={{ 
        zIndex: 0, 
        opacity: 0.4,
        backgroundImage: `radial-gradient(circle at 2px 2px, #e2e8f0 1px, transparent 0)`,
        backgroundSize: '32px 32px'
      }}></div>

      {/* Hero Section */}
      <section className="container position-relative pt-6" style={{ zIndex: 1 }}>
        <div className="row align-items-center g-5 min-vh-75">
          
          <div className="col-lg-6 text-center text-lg-start">
          
            
            <h1 className="fw-bold mb-4" data-aos="fade-up" style={{ 
              fontSize: 'clamp(2.5rem, 5vw, 4rem)', 
              color: '#1e293b',
              lineHeight: 1.1,
              letterSpacing: '-0.04em'
            }}>
              Where Wellness <br/>
              <span style={{ color: 'var(--secondaryColor, #f4911e)' }}>Meets Community</span>
            </h1>

            <p className="lead text-muted mb-5" data-aos="fade-up" data-aos-delay="100" style={{ maxWidth: '540px' }}>
              Connect with health-conscious individuals and medical professionals in a privacy-first environment designed for institutional-grade wellness networking.
            </p>

            {/* Feature Pills */}
            <div className="d-flex flex-wrap justify-content-center justify-content-lg-start gap-3 mb-5" data-aos="fade-up" data-aos-delay="200">
              {[
                { icon: <FaUsers />, label: "Wellness Networking" },
                { icon: <FaShieldAlt />, label: "Privacy-First" }
              ].map((pill, i) => (
                <div key={i} className="d-flex align-items-center gap-2 px-3 py-2 rounded-1 border bg-white shadow-sm" style={{ fontSize: '0.85rem', fontWeight: '600' }}>
                  <span className="text-primary">{pill.icon}</span> {pill.label}
                </div>
              ))}
            </div>

            <div className="d-flex flex-column flex-sm-row justify-content-center justify-content-lg-start gap-3" data-aos="fade-up" data-aos-delay="300">
              <a href="#ios" className="btn btn-dark btn-lg px-4 py-3 d-flex align-items-center gap-3 rounded-1 shadow-lg" style={{ fontSize: '0.9rem' }}>
                <FaApple size={24} /> 
                <div className="text-start">
                  <div style={{ fontSize: '0.6rem', opacity: 0.7, textTransform: 'uppercase' }}>Download on the</div>
                  <div className="fw-bold">App Store</div>
                </div>
              </a>
              <a href="#android" className="btn btn-outline-dark btn-lg px-4 py-3 d-flex align-items-center gap-3 rounded-1" style={{ fontSize: '0.9rem' }}>
                <FaGooglePlay size={22} /> 
                <div className="text-start">
                  <div style={{ fontSize: '0.6rem', opacity: 0.7, textTransform: 'uppercase' }}>Get it on</div>
                  <div className="fw-bold">Google Play</div>
                </div>
              </a>
            </div>
          </div>

          <div className="col-lg-6" data-aos="zoom-in" data-aos-delay="400">
            <div className="position-relative mx-auto" style={{ maxWidth: '500px' }}>
              {/* Decorative Circle */}
              <div className="position-absolute top-50 start-50 translate-middle" style={{ 
                width: '120%', height: '120%', 
                background: 'radial-gradient(circle, rgba(244,145,30,0.08) 0%, transparent 70%)',
                zIndex: -1 
              }}></div>
              
              <img 
                src={productImg} 
                alt="AfyaMingle Interface" 
                className="img-fluid floating-phone"
                style={{ filter: 'drop-shadow(0 30px 60px rgba(0,0,0,0.12))' }}
              />
            </div>
          </div>

        </div>
      </section>

      <style>{`
        .floating-phone {
          animation: floatImg 6s ease-in-out infinite;
        }
        @keyframes floatImg {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-20px); }
        }
        .tracking-widest { letter-spacing: 0.15em; }
        .pt-6 { padding-top: 6rem; }
        .min-vh-75 { min-height: 75vh; }
      `}</style>
    </main>
  );
}